import scrollLock from './scrollLock';

const toggleBodyClassOnHover = () => {
  const menuItems = document.querySelectorAll(
    '.c-nav__item--main.menu-item-has-children',
  );
  const bp = window.matchMedia('(min-width: 1024px)');

  if (bp.matches) {
    menuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        document.body.classList.add('menu-open');
        scrollLock.lock('.c-header');
      });
      item.addEventListener('mouseleave', () => {
        document.body.classList.remove('menu-open');
        scrollLock.unlock('.c-header');
      });
    });
  }
};

window.addEventListener('DOMContentLoaded', toggleBodyClassOnHover);
